import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, UncontrolledTooltip } from 'reactstrap';
import { AiOutlineFullscreen } from "react-icons/ai";
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { toast, ToastContainer } from 'react-toastify'
import { RingLoader } from 'react-spinners';
import './panels.css';

const API_URL = process.env.REACT_APP_API_URL;
const REPORT_ID = process.env.REACT_APP_POWERBI_REPORT_ANEXOI;


export default function ReportDisponibilidade() {

    const [statusAzure, setStatusAzure] = useState(null);
    const [tipoPanel, setTipoPanel] = useState(null);
    const [status, setStatus] = useState(null);
    const [pbiToken, setPbiToken] = useState(null);

    useEffect(() => {
        if (status) {
            toast.warn(status);
            setStatus(null);
        }
    }, [status])

    const [reportConfig, setReportConfig] = useState({
        type: 'report',
        embedUrl: undefined,
        tokenType: models.TokenType.Embed,
        accessToken: undefined,
        settings: {
            localeSettings: {
                language: "pt",
                formatLocale: "pt-BR"
            }
        }
    });      

    // Validação se o serviço da Azure está habilitado
    useEffect(() => {
        if ( tipoPanel === null ) {
            let interval = setInterval(() => {
                fetch(API_URL, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },        
                    body: JSON.stringify({
                        'name': 'paineis',
                        'params': {
                            'action': 'init_azure_capacity'
                        }
                    })
                })
                .then(response => response.json())
                .then(data => {
                    setStatusAzure(data.message);
                })
                .catch(error => {
                    console.error(error);
                    setStatus("Erro ao verificar o status do serviço de relatórios.");
                })
            }, 1000);            
            return () => clearInterval(interval);
        }
    }, [tipoPanel])    

    // Configura o dashboard caso  serviço da Azure esteja habilitado
    useEffect(() => {    
        if (statusAzure === 'Succeeded') {
            setTipoPanel('paginatedReport');
            const token = localStorage.getItem('@ProsperBI:pbiToken');
            setPbiToken(token);
        }    
    }, [statusAzure]);    

    useEffect(() => {   
        if (pbiToken) {
            fetch(API_URL, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'name': 'paineis',
                    'params': {
                        'action': 'get_panel',
                        'data': {
                            'panel_type': 'PaginatedReport',
                            'panel_id': REPORT_ID,
                            'pbi_token': pbiToken
                        }
                    }
                })
            })
            .then(response => response.json())
            .then(data => {
                setReportConfig({
                    type: 'report',
                    embedUrl: data.panel.embedUrl.url,
                    tokenType: models.TokenType.Embed,
                    accessToken: data.panel.accessToken,
                    settings: {
                        localeSettings: {
                            language: "pt",
                            formatLocale: "pt-BR"
                        }
                    }
                })                   
            })
            .catch(error => {
                console.error(error);
                setStatus("Erro ao carregar o relatório.");
            })
        } 
    }, [pbiToken])

    const reportFullscreen = () => {
        if (window.pbiReport) {
            window.pbiReport.fullscreen();
        }
    }    

    const reportEventHandlers = new Map([
        ['rendered', function (event) {
            fetch(API_URL, {
                method: "POST",
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: 'security',
                    params: {
                        bpoToken: localStorage.getItem('@ProsperBI:pbiToken'),
                        eventType: 'panel_access'
                    }
                })
            })            
        }],    
    ]);

    if ( (statusAzure !== 'Succeeded') ) {
        return (
            <>
                <div className="d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3">
                    <div className="d-flex align-items-center flex-column px-4">
                        <RingLoader color={'#122e4d'} loading={true} />
                    </div>
                    <div className="text-muted font-size-xl text-center pt-3">
                        Aguarde enquanto o servidor de relatórios é inicializado...
                    </div>
                </div>
            </>
        );
    }
    else if (tipoPanel == null) {
        return (
            <>
                <div className="d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3">
                    <div className="d-flex align-items-center flex-column px-4">
                        <RingLoader color={'#122e4d'} loading={true} />
                    </div>
                    <div className="text-muted font-size-xl text-center pt-3">
                        Aguarde enquanto as informações do relatório são carregadas...
                    </div>
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <ToastContainer position="top-right" />
                <Container fluid
                    style={{
                    width: "100%",        
                    padding: 0,
                    border: "0px",
                    height: "100vh"
                }}>
                <Row >    
                <Col style={{ height: "100vh" }} >
                    <Card>
                    <Row className="report-header">
                        <Col>
                        </Col>
                        <Col xs="auto">
                        <AiOutlineFullscreen 
                            className="report-header-icon" 
                            id="tipReportFull"
                            onClick={reportFullscreen}
                        />
                        <UncontrolledTooltip placement="bottom" target="tipReportFull">
                            Tela Inteira
                        </UncontrolledTooltip>         
                        </Col>                    
                    </Row>
                    <PowerBIEmbed 
                        embedConfig = { reportConfig }            
                        eventHandlers = { reportEventHandlers }
                        cssClassName = { "report-style-class" }
                        getEmbeddedComponent = { (embedObject) => {
                            window.pbiReport = embedObject;
                        }}            
                        />              
                    </Card>
                </Col>      
                </Row>
            </Container>      
            </>
        );
    };
}